import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { DepartmentData } from '../model/response/department-data';
import { departmentApi } from '../administration/department-api';
import { Department } from '../model/department';
import request from 'src/utils/request';

export interface DepartmentState {
  myDept: {
    data: any[] | Department[];
    status: 'idle' | 'loading' | 'ready';
  };
  all: {
    data: any[] | DepartmentData[];
    status: 'idle' | 'loading' | 'ready';
  };
}

const initialState: DepartmentState = {
  myDept: {
    data: [],
    status: 'idle',
  },
  all: {
    data: [],
    status: 'idle',
  },
};

export const getMyDepartment = createAsyncThunk(
  'dept/myself',
  async (arg: any, { getState }) => {
    const state = getState() as RootState;
    if (state.department.myDept.status === 'idle') {
      if (arg.deptId) {
        const res = await departmentApi.findAllSubDepartments(
          { deptId: arg.deptId, keyword: '' },
          {
            page: 0,
            size: 100,
            sort: 'asc',
            order: 'path',
          },
        );
        return res;
      } else return [];
    }
  },
);

type UnitTreeNode = {
  key: string;
  title: string;
  icon?: string;
  folder?: boolean;
  active?: boolean;
  children?: UnitTreeNode[];
};

export const getAllDepartment = createAsyncThunk(
  'dept/all',
  async () => {
    const res = await request.get('/api/units/tree');
    const tree: UnitTreeNode[] = res?.data?.data || [];
    const flat: DepartmentData[] = [];

    const traverse = (
      nodes: UnitTreeNode[],
      parentId: string = '',
      parentName: string = '',
    ) => {
      nodes.forEach(node => {
        const isActive = node.active !== false;

        if (isActive) {
          flat.push({
            id: node.key,
            deptCode: '',
            deptName: node.title,
            parentId,
            parentName,
          });
        }

        if (node.children && node.children.length > 0) {
          traverse(node.children, node.key, node.title);
        }
      });
    };

    traverse(tree);
    return flat;
  },
);

export const deptSlice = createSlice({
  name: 'dept',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      getMyDepartment.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.myDept = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
    builder.addCase(
      getAllDepartment.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.all = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
  },
});

export const selectDepartment = (state: RootState) =>
  state.department;

export default deptSlice.reducer;
